import { localStorage } from "../customizer/__constant";
import $ from "jquery";
import { LocalStorage } from "storage-manager-js";
import handleSendPostData from "../../utils/handle-send-post-data";

const cartOfferte = () => {
  const el = {
    button: ".js-offerte",
  };

  const init = () => {
    if ($(el.button).length === 0) return;
    loadDataOfferte();
    goesToOfferte();
  };

  const loadDataOfferte = () => {
    const dataOfferte = LocalStorage.get(localStorage.cartOfferte);
    $(`${el.button}__input`).val(JSON.stringify(dataOfferte));
  };

  const goesToOfferte = () => {
    handleSendPostData(el.button);
  };

  init();
};

try {
  cartOfferte();
} catch (error) {
  console.error("cartOfferte", error);
}
